'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Horizontal tabs are designed with 100% width. Any text that is greater will wrap.
 * Tabs will have independent sizes based on their text width.
 *
 * Vertical tabs are designed with a max-width of 200px.
 * We use box-sizing and text wrapping to allow for the same width on multiple tabs.
 *
 * Usage:
 *
 * ```Javascript
 * <NavigationTabs isVertical>
 * 	{ Children }
 * </NavigationTabs>
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} isVertical Defines whether to render the navigation tabs vertically or horizontally.
 */

class NavigationTabs extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName (isVertical) {
    return classNames({
      'Tabs': true,
      'Tabs--vertical': isVertical,
      'Showcase--vertical': isVertical
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { isVertical } = this.props;
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {isVertical: isVertical});
    });

    return (
      <nav className={this.getClassName(isVertical)} >
        { children }
      </nav>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the NavigationTabs component
 */
NavigationTabs.propTypes = {
  isVertical: React.PropTypes.bool
};

NavigationTabs.defaultProps = {
  isVertical: false
};

export default NavigationTabs;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/tabs/navigationTabs.jsx